import { useNetworkMutation } from '@/lib/utils/request'

export interface DeleteAlertByIdPayload extends Record<string, unknown> {
  params: { id: string }
}

export const useDeleteAlert = () =>
  useNetworkMutation<void, DeleteAlertByIdPayload>({
    url: 'v1/alerts/${params.id}/',
    method: 'delete',
  })
